(function () {
  'use strict';

  var S = (window.BYLILY && window.BYLILY.strings) || {};
  var R = (window.BYLILY && window.BYLILY.routes) || { cart_add: '/cart/add', cart_url: '/cart' };

  function parseJSONScript(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function setError(el, message) {
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-visible', !!message);
  }

  function isValidMeasurement(value) {
    if (value === '' || value === null || typeof value === 'undefined') return false;
    var n = Number(value);
    return isFinite(n) && n > 0;
  }

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var unit = root.getAttribute('data-unit') || '';
    var bodySizes = parseJSONScript(root, '[data-body-sizes]') || {};
    var sleeveMap = parseJSONScript(root, '[data-sleeve-map]') || {};

    var sizingEnabled = root.hasAttribute('data-sizing-enabled');
    var readyEnabled = root.hasAttribute('data-ready-enabled');
    var customEnabled = root.hasAttribute('data-custom-enabled');

    var typeButtons = root.querySelectorAll('[data-size-type]');
    var readyPanel = root.querySelector('[data-ready-panel]');
    var customPanel = root.querySelector('[data-custom-panel]');
    var summary = root.querySelector('[data-summary]');
    var summaryTitle = root.querySelector('[data-summary-title]');
    var summaryList = root.querySelector('[data-summary-list]');
    var errorBox = root.querySelector('[data-form-error]');

    var inputs = {
      sizeType: root.querySelector('[data-prop="Size Type"]'),
      standardSize: root.querySelector('[data-prop="Standard Size"]'),
      shoulder: root.querySelector('[data-prop="Shoulder"]'),
      bust: root.querySelector('[data-prop="Bust"]'),
      armhole: root.querySelector('[data-prop="Armhole"]'),
      abaya: root.querySelector('[data-prop="Abaya Length"]'),
      sleeve: root.querySelector('[data-prop="Sleeve Length"]')
    };
    var custom = {
      shoulder: root.querySelector('[data-custom="Shoulder"]'),
      bust: root.querySelector('[data-custom="Bust"]'),
      armhole: root.querySelector('[data-custom="Armhole"]'),
      abaya: root.querySelector('[data-custom="Abaya Length"]'),
      sleeve: root.querySelector('[data-custom="Sleeve Length"]')
    };

    var state = { mode: null, size: null, length: null };

    function disableSet(obj, disabled) {
      Object.keys(obj).forEach(function (k) {
        if (obj[k]) obj[k].disabled = disabled;
      });
    }

    /* Ready-made hidden inputs must not be submitted in custom mode and vice versa */
    function syncDisabledState() {
      if (!sizingEnabled) return;
      var readyMode = state.mode === 'Ready-Made';
      // Ready-made derived hidden inputs
      [inputs.standardSize, inputs.shoulder, inputs.bust, inputs.armhole, inputs.abaya, inputs.sleeve].forEach(function (el) {
        if (el) el.disabled = !readyMode;
      });
      disableSet(custom, readyMode);
      if (inputs.sizeType) inputs.sizeType.disabled = !state.mode;
    }

    function renderSummary() {
      if (!summary || !summaryList) return;
      var rows = [];
      if (state.mode === 'Ready-Made' && state.size) {
        var m = bodySizes[state.size] || {};
        rows.push([root.getAttribute('data-label-size') || 'Size', state.size]);
        rows.push([root.getAttribute('data-label-shoulder') || 'Shoulder', m.shoulder + unit]);
        rows.push([root.getAttribute('data-label-bust') || 'Bust', m.bust + unit]);
        rows.push([root.getAttribute('data-label-armhole') || 'Armhole', m.armhole + unit]);
        if (state.length) {
          rows.push([root.getAttribute('data-label-abaya') || 'Abaya length', state.length + unit]);
          rows.push([root.getAttribute('data-label-sleeve') || 'Sleeve length', sleeveMap[state.length] + unit]);
        }
        if (summaryTitle) summaryTitle.textContent = root.getAttribute('data-title-selection') || 'Your selection';
      } else if (state.mode === 'Custom Measurements') {
        var pairs = [
          ['Shoulder', custom.shoulder, 'data-label-shoulder'],
          ['Bust', custom.bust, 'data-label-bust'],
          ['Armhole', custom.armhole, 'data-label-armhole'],
          ['Abaya Length', custom.abaya, 'data-label-abaya'],
          ['Sleeve Length', custom.sleeve, 'data-label-sleeve']
        ];
        pairs.forEach(function (p) {
          if (p[1] && p[1].value !== '') rows.push([root.getAttribute(p[2]) || p[0], p[1].value + unit]);
        });
        if (summaryTitle) summaryTitle.textContent = root.getAttribute('data-title-measurements') || 'Your measurements';
      }
      if (!rows.length) { summary.hidden = true; summaryList.innerHTML = ''; return; }
      summary.hidden = false;
      summaryList.innerHTML = rows.map(function (r) {
        return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>';
      }).join('');
    }

    function setMode(mode) {
      state.mode = mode;
      typeButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-size-type') === mode ? 'true' : 'false');
      });
      if (readyPanel) readyPanel.hidden = mode !== 'Ready-Made';
      if (customPanel) customPanel.hidden = mode !== 'Custom Measurements';
      if (inputs.sizeType) inputs.sizeType.value = mode || '';
      syncDisabledState();
      setError(errorBox, '');
      renderSummary();
    }

    typeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { setMode(btn.getAttribute('data-size-type')); });
    });

    /* Ready-made body size */
    root.querySelectorAll('[data-body-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var size = btn.getAttribute('data-body-size');
        state.size = size;
        root.querySelectorAll('[data-body-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var m = bodySizes[size] || {};
        if (inputs.standardSize) inputs.standardSize.value = size;
        if (inputs.shoulder) inputs.shoulder.value = m.shoulder;
        if (inputs.bust) inputs.bust.value = m.bust;
        if (inputs.armhole) inputs.armhole.value = m.armhole;
        var detail = root.querySelector('[data-size-detail]');
        if (detail) {
          detail.hidden = false;
          detail.innerHTML = '<strong>' + (root.getAttribute('data-label-size') || 'Size') + ' ' + size + '</strong> — ' +
            (root.getAttribute('data-label-shoulder') || 'Shoulder') + ': ' + m.shoulder + unit + ' · ' +
            (root.getAttribute('data-label-bust') || 'Bust') + ': ' + m.bust + unit + ' · ' +
            (root.getAttribute('data-label-armhole') || 'Armhole') + ': ' + m.armhole + unit;
        }
        syncDisabledState();
        renderSummary();
      });
    });

    /* Ready-made abaya length -> sleeve length */
    function applyLength(len) {
      state.length = len;
      if (inputs.abaya) inputs.abaya.value = len;
      var sleeve = sleeveMap[len];
      if (inputs.sleeve) inputs.sleeve.value = typeof sleeve === 'undefined' ? '' : sleeve;
      var out = root.querySelector('[data-sleeve-output]');
      if (out) {
        out.hidden = false;
        out.textContent = (root.getAttribute('data-label-sleeve') || 'Sleeve length') + ': ' + sleeve + unit;
      }
      syncDisabledState();
      renderSummary();
    }

    root.querySelectorAll('[data-abaya-length]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-abaya-length]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        applyLength(btn.getAttribute('data-abaya-length'));
      });
    });
    var lengthSelect = root.querySelector('[data-abaya-length-select]');
    if (lengthSelect) {
      lengthSelect.addEventListener('change', function () {
        if (lengthSelect.value) applyLength(lengthSelect.value);
      });
    }

    Object.keys(custom).forEach(function (k) {
      if (custom[k]) custom[k].addEventListener('input', function () { setError(errorBox, ''); renderSummary(); });
    });

    /* Optional color property buttons */
    root.querySelectorAll('[data-color-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-color-value]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var target = root.querySelector('[data-prop="Color"]');
        if (target) { target.value = btn.getAttribute('data-color-value'); target.disabled = false; }
      });
    });

    function validate() {
      setError(errorBox, '');
      if (!sizingEnabled) return true;
      if (!state.mode) { setError(errorBox, S.select_size); return false; }
      if (state.mode === 'Ready-Made') {
        if (!state.size) { setError(errorBox, S.select_size); return false; }
        if (!state.length) { setError(errorBox, S.select_length); return false; }
        return true;
      }
      var checks = [
        [custom.shoulder, S.enter_shoulder],
        [custom.bust, S.enter_bust],
        [custom.armhole, S.enter_armhole],
        [custom.abaya, S.enter_abaya_length],
        [custom.sleeve, S.enter_sleeve_length]
      ];
      for (var i = 0; i < checks.length; i++) {
        var el = checks[i][0];
        if (!el) continue;
        if (!isValidMeasurement(el.value)) {
          setError(errorBox, el.value === '' ? checks[i][1] : S.invalid_number);
          el.focus();
          return false;
        }
      }
      return true;
    }

    /* Remove any blank/disabled optional properties before submit */
    function cleanOptionalProps() {
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if (el.type === 'hidden' || el.tagName === 'TEXTAREA' || el.type === 'text' || el.type === 'number') {
          if (!el.disabled && String(el.value).trim() === '') el.disabled = true;
        }
      });
    }

    function restoreProps() { syncDisabledState(); }

    function addToCart(redirectToCheckout) {
      if (!validate()) return;
      cleanOptionalProps();
      var submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      fetch(R.cart_add + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) {
            setError(errorBox, (result.json && result.json.description) || S.generic_error);
            return;
          }
          if (redirectToCheckout) { window.location.href = '/checkout'; return; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { sections: result.json.sections } }));
        })
        .catch(function () { setError(errorBox, S.generic_error); })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('aria-disabled');
          restoreProps();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(false);
    });

    var buyNow = root.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(true);
      });
    }

    /* Sticky mobile add to bag */
    var sticky = root.querySelector('[data-sticky-atc]');
    if (sticky) {
      var anchor = root.querySelector('[data-add-to-cart]');
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0 }).observe(anchor);
      }
      sticky.querySelector('button').addEventListener('click', function () {
        if (sizingEnabled && !state.mode) {
          root.querySelector('[data-size-type]').scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        addToCart(false);
      });
    }

    /* Initial mode */
    if (sizingEnabled) {
      if (readyEnabled) setMode('Ready-Made');
      else if (customEnabled) setMode('Custom Measurements');
    } else if (inputs.sizeType) {
      inputs.sizeType.disabled = true;
    }
  });

  /* Variant selection (native Shopify variants) */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var root = picker.closest('[data-product-root]');
    var variants = null;
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');

    function selectedOptions() {
      var opts = [];
      picker.querySelectorAll('[data-option-index]').forEach(function (group) {
        var pressed = group.querySelector('[aria-pressed="true"]');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = pressed ? pressed.getAttribute('data-option-value') : null;
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.filter(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      var priceEl = root.querySelector('[data-price-target]');
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      var atc = root.querySelector('[data-add-to-cart]');
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.getAttribute('data-label-available') : atc.getAttribute('data-label-soldout');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        update();
      });
    });
  });
})();
